// La razón es la misma frase del 403 de esa puerta (identity-access-spec §1a.3); solo god mode,
// que no trae razón, cae al copy genérico.
export function gateTooltip(allowed: boolean, blockedReason: string | null, t: (key: string) => string) {
  if (allowed) return undefined
  return blockedReason ?? t('marcado.godMode.tooltip')
}
